module.exports = __webpack_public_path__ + "28c1541ebf2cdd986ebaa693ff5a2351.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/lankenau03.jpg
// module id = 800
// module chunks = 0